const authState = { token: '' };

export function getAuthToken(): string {
  return authState.token;
}

export function setAuthToken(token: string) {
  authState.token = token;
}
